import React, { FC, useState, useRef, useEffect, useContext } from 'react'
import Modal from 'react-modal'
import { usePromiseTracker } from 'react-promise-tracker'
import { trackPromise } from 'react-promise-tracker'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import AppContext from '../../../context/appContext'

import { getUserWeeklyActivity } from '../../../Api/backendApi'

import {
  modalStyles,
  PopupContainer,
  Row,
  Column,
  Image,
  Text,
  CalendarTile,
  ActiveDayCompletedIcon,
  Button,
} from '../../VideoScreen/styles/VideoScreenStyles'

import Loader from '../../Loader/Loader'

import thumbsUpImage from '../../../assets/player/thumbsUpIcon.webp'
import okCheckIcon from '../../../assets/player/okCheckIcon.webp'

interface IlastWatchedVideoAlbum {
  album_id: number
  id: number
  title: string
}

interface IlastWatchedVideoFromThisFolder {
  album: IlastWatchedVideoAlbum
  id: number
  is_intro: boolean
  is_locked: boolean
  is_watched: boolean
  locked_datetime: string
  video_id: number
  video_order_id: number
  watched_datetime: string
}

interface AfterTrainingPopupProps {
  isAfterTrainingPopupOpen: boolean
  toggleAfterTrainingPopupOpen: Function
  lastWatchedVideoFromThisFolder: IlastWatchedVideoFromThisFolder
  completedMiazgaTrainingName: Function
}

const AfterTrainingPopup: FC<AfterTrainingPopupProps> = ({
  isAfterTrainingPopupOpen,
  toggleAfterTrainingPopupOpen,
  lastWatchedVideoFromThisFolder,
  completedMiazgaTrainingName,
}) => {
  const afterTrainingPopup = useRef(null)
  Modal.setAppElement('#root')
  const [userWeeklyActivity, setUserWeeklyActivity] = useState([])
  const { promiseInProgress } = usePromiseTracker()
  const appContext = useContext(AppContext)

  const getUserActivity = async () => {
    let userActivity : any

    if(appContext && !appContext.appState.userActivity){
      userActivity = await trackPromise(getUserWeeklyActivity())
      appContext.updateAppState("userActivity",userActivity )
    }else{
      userActivity = appContext.appState.userActivity
    }
    setUserWeeklyActivity(userActivity as any)
  }

  // run once to gather info about user weekly activity
  useEffect(() => {
    getUserActivity()
  }, [])

  return (
    <Modal
      ref={afterTrainingPopup}
      isOpen={isAfterTrainingPopupOpen}
      onRequestClose={() => toggleAfterTrainingPopupOpen(false)}
      style={modalStyles}
    >
      <PopupContainer>
        {/* Row width first line text */}
        <Row margin={`5px 0`}>
          <Text
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={isMobile ? 36 : 40}
            display={'inline-block'}
          >
            {completedMiazgaTrainingName() + ' ukończony!'}
          </Text>
        </Row>

        {/* Row width second line text */}
        <Row margin={`5px 0`}>
          <Text
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={isMobile ? 36 : 40}
            display={'inline-block'}
          >
            Dobra robota!
          </Text>
        </Row>

        {/* Row width thumbs up image */}
        <Row margin={`15px 0 0 0 `}>
          <Image
            src={thumbsUpImage}
            height={
              isMobile
                ? '170px'
                : isMobile && window.innerWidth < 360
                ? '130px'
                : '10vw'
            }
          />
        </Row>

        {/* Row width date */}
        <Row margin={`45px 0 20px 0`} width={'100%'} justify={'space-around'}>
          <Column alignItems={isMobile ? 'flex-start' : 'center'} width={'50%'}>
            <Text
              textAlign={'center'}
              fontWeight={'bold'}
              fontSize={isMobile ? 24 : 26}
              display={'inline-block'}
            >
              {`Tydzień ${moment().format('w')}`}
            </Text>
          </Column>

          <Column width={'50%'} alignItems={isMobile ? 'flex-end' : 'center'}>
            <Row justify={isMobile ? 'flex-end' : 'center'}>
              <Text
                textAlign={'center'}
                fontWeight={'bold'}
                fontSize={isMobile ? 24 : 26}
                display={'inline-block'}
              >
                {moment().format('D MMMM')}
              </Text>
              <Text
                margin={'0 0 0 15px'}
                textAlign={'center'}
                fontWeight={'normal'}
                fontSize={isMobile ? 24 : 26}
                display={'inline-block'}
              >
                {moment().format('YYYY')}
              </Text>
            </Row>
          </Column>
        </Row>

        {/* Row width calendar tiles */}
        <Row justify="flex-start">
          {userWeeklyActivity &&
            userWeeklyActivity.map((userSingleDayActivity: any) => (
              <CalendarTile
                key={userSingleDayActivity.date}
                className={userSingleDayActivity.is_today_date ? 'active' : ''}
                justify={'center'}
                alignItems={'center'}
              >
                <Text
                  textAlign={'left'}
                  fontWeight={'bold'}
                  fontSize={isMobile ? 24 : 22}
                  display={'inline-block'}
                  color={' #212121'}
                  position={'absolute'}
                  left={isMobile ? '5px' : '10px'}
                  top={isMobile ? '5px' : '10px'}
                >
                  {moment(userSingleDayActivity.date).format('ddd')}
                </Text>
                <Text
                  textAlign={'left'}
                  fontWeight={'bold'}
                  fontSize={isMobile ? 24 : 22}
                  display={'inline-block'}
                  color={' #212121'}
                  position={'absolute'}
                  bottom={isMobile ? '5px' : '10px'}
                  right={isMobile ? '5px' : '10px'}
                >
                  {moment(userSingleDayActivity.date).format('D')}
                </Text>
                {userSingleDayActivity.is_training_done && (
                  <ActiveDayCompletedIcon src={okCheckIcon} />
                )}
              </CalendarTile>
            ))}
        </Row>

        {/* Row width button */}
        <Row margin={'40px 0'}>
          <Button width={'60%'} onClick={toggleAfterTrainingPopupOpen}>
            idę odpocząć
          </Button>
        </Row>
      </PopupContainer>
      {promiseInProgress && <Loader />}
    </Modal>
  )
}

export default AfterTrainingPopup
